if (!customElements.get('brand-directory')) {
  class BrandDirectory extends HTMLElement {
    connectedCallback() {
      this.searchInput = this.querySelector('[data-brand-search]');
      this.clearButton = this.querySelector('[data-brand-clear]');
      this.items = Array.from(this.querySelectorAll('[data-brand-item]'));
      this.groups = Array.from(this.querySelectorAll('[data-brand-group]'));
      this.emptyMessage = this.querySelector('[data-brand-empty]');
      this.count = this.querySelector('[data-brand-count]');
      this.countLabel = this.querySelector('[data-brand-count-label]');

      this.sortDirectoryBrands();
      this.sortFeaturedBrands();

      if (!this.searchInput) return;

      this.onInput = this.filterBrands.bind(this);
      this.onClear = this.clearSearch.bind(this);

      this.searchInput.addEventListener('input', this.onInput);

      if (this.clearButton) {
        this.clearButton.addEventListener('click', this.onClear);
      }
    }

    disconnectedCallback() {
      if (this.searchInput && this.onInput) {
        this.searchInput.removeEventListener('input', this.onInput);
      }

      if (this.clearButton && this.onClear) {
        this.clearButton.removeEventListener('click', this.onClear);
      }
    }

    sortFeaturedBrands() {
      const list = this.querySelector('[data-featured-brands]');
      if (!list) return;

      Array.from(list.children)
        .sort((a, b) => {
          const priorityDifference =
            Number(a.dataset.priority) - Number(b.dataset.priority);

          return (
            priorityDifference ||
            a.dataset.name.localeCompare(b.dataset.name)
          );
        })
        .forEach((item) => list.appendChild(item));
    }

    sortDirectoryBrands() {
      this.querySelectorAll('[data-brand-list]').forEach((list) => {
        Array.from(list.children)
          .sort((a, b) =>
            a.dataset.brandName.localeCompare(
              b.dataset.brandName,
              undefined,
              { numeric: true }
            )
          )
          .forEach((item) => list.appendChild(item));
      });
    }

    filterBrands() {
      const query = this.searchInput.value
        .trim()
        .toLocaleLowerCase();

      let visibleCount = 0;

      this.items.forEach((item) => {
        const visible = item.dataset.brandName.includes(query);
        item.hidden = !visible;

        if (visible) visibleCount += 1;
      });

      this.groups.forEach((group) => {
        const hasVisibleItems = group.querySelector(
          '[data-brand-item]:not([hidden])'
        );

        group.hidden = !hasVisibleItems;

        const letterLink = this.querySelector(
          `[data-letter-link="${CSS.escape(group.dataset.letter)}"]`
        );

        if (letterLink) {
          letterLink.toggleAttribute(
            'aria-disabled',
            !hasVisibleItems
          );
        }
      });

      if (this.clearButton) {
        this.clearButton.hidden = query.length === 0;
      }

      if (this.emptyMessage) {
        this.emptyMessage.hidden = visibleCount !== 0;
      }

      if (this.count) {
        this.count.textContent = visibleCount;
      }

      if (this.countLabel) {
        this.countLabel.textContent =
          visibleCount === 1
            ? this.countLabel.dataset.singular
            : this.countLabel.dataset.plural;
      }
    }

    clearSearch() {
      this.searchInput.value = '';
      this.filterBrands();
      this.searchInput.focus();
    }
  }

  customElements.define('brand-directory', BrandDirectory);
}